import { Link } from 'react-router-dom'
import { Camera } from 'lucide-react'
import { LEGAL } from '@/lib/legal'

type FooterLink = { label: string; to?: string; href?: string }

const COLUMNS: [string, FooterLink[]][] = [
  ['Product', [
    { label: 'How it works', href: '/#how' },
    { label: 'Features', href: '/#features' },
    { label: 'Pricing', to: '/pricing' },
  ]],
  ['Use cases', [
    { label: 'Weddings', href: '/#usecases' },
    { label: 'Trips & reunions', href: '/#usecases' },
    { label: 'Parties', href: '/#usecases' },
    { label: 'Events & teams', href: '/#usecases' },
  ]],
  ['Legal', [
    { label: 'Privacy', to: '/privacy' },
    { label: 'Terms', to: '/terms' },
  ]],
]

function FooterItem({ link }: { link: FooterLink }) {
  const cls = 'pd-navlink'
  const style = { fontSize: '.92rem' }
  return link.to ? (
    <Link to={link.to} className={cls} style={style}>{link.label}</Link>
  ) : (
    <a href={link.href} className={cls} style={style}>{link.label}</a>
  )
}

export function Footer() {
  return (
    <footer style={{ borderTop: '1px solid hsl(var(--border))', background: 'hsl(var(--background))' }}>
      <div
        className="pd-footer-grid"
        style={{ maxWidth: 1200, margin: '0 auto', padding: '64px 28px 40px', display: 'grid', gridTemplateColumns: '1.6fr repeat(3, 1fr)', gap: 34 }}
      >
        <div>
          <Link to="/" className="flex items-center gap-2" style={{ color: 'hsl(var(--foreground))' }}>
            <span
              className="grid place-items-center text-white"
              style={{ width: 30, height: 30, borderRadius: 9, background: 'linear-gradient(135deg, hsl(var(--gradient-start)), hsl(var(--gradient-middle)), hsl(var(--gradient-end)))' }}
            >
              <Camera style={{ width: 17, height: 17 }} />
            </span>
            <span className="fdisplay" style={{ fontWeight: 800, fontSize: '1.32rem', letterSpacing: '-.02em' }}>photodrop</span>
          </Link>
          <p style={{ color: 'hsl(var(--muted-foreground))', maxWidth: 260, marginTop: 16, lineHeight: 1.55, fontSize: '.95rem' }}>
            The easiest way to gather everyone's photos from any moment — no accounts, no hassle.
          </p>
        </div>
        {COLUMNS.map(([heading, items]) => (
          <div key={heading}>
            <div className="fdisplay" style={{ fontWeight: 700, marginBottom: 14 }}>{heading}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {items.map((it) => <FooterItem key={it.label} link={it} />)}
            </div>
          </div>
        ))}
      </div>
      <div
        style={{ maxWidth: 1200, margin: '0 auto', padding: '18px 28px 40px', borderTop: '1px solid hsl(var(--border))', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, color: 'hsl(var(--muted-foreground))', fontSize: '.86rem' }}
      >
        <span>© {new Date().getFullYear()} {LEGAL.entity}. {LEGAL.product} is a product of {LEGAL.entity}.</span>
        <span className="fmono">photodrop.dev</span>
      </div>
    </footer>
  )
}
